import { render, staticRenderFns } from "./SpecialInitiativesTrendTable.vue?vue&type=template&id=18eb3204&scoped=true&"
import script from "./SpecialInitiativesTrendTable.vue?vue&type=script&lang=ts&"
export * from "./SpecialInitiativesTrendTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialInitiativesTrendTable.vue?vue&type=style&index=0&id=18eb3204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb3204",
  null
  
)

export default component.exports